/**
 * Admin authorization check using Better Auth's role field.
 */
export function isAdmin(
  user: { role?: string | null } | undefined | null,
): boolean {
  return user?.role === 'admin'
}
